import React from 'react';
import { useTimeRange } from '../contexts/TimeRangeContext';

/**
 * TimeWindowPicker - Segment pill group for time range selection
 * Mock2-style: rounded pills in a row, active pill gets accent color
 * Wrapped with label to align with Env/App selector cards
 */
const TimeWindowPicker = () => {
  const { selectedRange, setSelectedRange } = useTimeRange();

  const presets = [
    { value: '1h', label: '1 hr' },
    { value: '24hours', label: '24 hrs' },
    { value: '7days', label: '7 days' },
    { value: '30days', label: '30 days' },
    { value: 'all-time', label: 'All time' },
  ];

  return (
    <div className="flex flex-col items-start px-1 py-2">
      <span className="block text-[10px] text-text-secondary uppercase tracking-wide mb-0.5 pl-2">Time</span>
      <div className="flex gap-1">
        {presets.map(({ value, label }) => (
          <button
            key={value}
            type="button"
            onClick={() => setSelectedRange(value)}
            className={`px-2.5 py-1 rounded-full text-sm font-medium transition-colors ${
              selectedRange === value
                ? 'bg-accent-primary-base text-text-inverse'
                : 'bg-background-tertiary text-text-supporting hover:bg-background-quaternary'
            }`}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TimeWindowPicker;
